import { PrincipalStore } from '../PrincipalStore'
import { User } from '@/shared/interfaces/User'
import { Cookies } from '@/shared/helpers/Cookies'
import { principalGetProfile } from './principalGetProfile'

/** Продлить срок жизни кук авторизации (скользящее окно в полгода). */
function renewAuthCookies(): void {
  const token = Cookies.get('authToken')
  const userId = Cookies.get('userId')
  if (!token || !userId) return

  const until = new Date()
  until.setMonth(until.getMonth() + 6)
  const options = { domain: window.location.hostname, path: '/', expires: until }
  Cookies.set('userId', userId, options)
  Cookies.set('authToken', token, options)
}

export async function principalRefresh(): Promise<User> {
  const { principalStore } = PrincipalStore.get()

  if (!Cookies.get('userId')) {
    principalStore.dispatch(async (state) => {
      state.userId = 0
      state.user = null
    })
  } else {
    const userId = +Cookies.get('userId')
    const user = await principalGetProfile(userId)
    // Продлеваем куки при каждом заходе: пока человек пользуется приложением,
    // повторный вход по СМС ему больше не понадобится.
    renewAuthCookies()

    principalStore.dispatch(async (state) => {
      state.userId = +Cookies.get('userId')
      state.user = user
    })
  }

  principalStore.dispatch(async (state) => {
    state.isLoading = false
  })

  return principalStore.state.user
}
